import { render, staticRenderFns } from "./CommentTab.vue?vue&type=template&id=bffa688a&"
import script from "./CommentTab.vue?vue&type=script&lang=js&"
export * from "./CommentTab.vue?vue&type=script&lang=js&"
import style0 from "./CommentTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bffa688a')) {
      api.createRecord('bffa688a', component.options)
    } else {
      api.reload('bffa688a', component.options)
    }
    module.hot.accept("./CommentTab.vue?vue&type=template&id=bffa688a&", function () {
      api.rerender('bffa688a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/CommentTab.vue"
export default component.exports